import * as Menu from '../../components/menu'
import * as Router from '../../router'
import {routes as calendar} from '../content-calendar'
import {routes as imports} from '../imports'
import {routes as leadPosts} from '../lead-posts'
import {routes as leadText} from '../lead-text'
import {routes as posts} from '../posts'
import {routes as promotions} from '../promotions'
import {routes as sources} from '../sources'

export const routes = [
  {
    action: (context: any) => (context.pathname === Menu.CONTENT_URL_HOME)
      ? context.store.dispatch(Router.push(Menu.CONTENT_POSTS_URL)).wat
      : context.next(context),
    path: Menu.CONTENT_URL_HOME,
  },
  ...calendar,
  ...imports,
  ...leadPosts,
  ...leadText,
  ...promotions,
  ...posts,
  ...sources,
]



// WEBPACK FOOTER //
// ./src/pages/content/routes.tsx